exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".WelcomePane p {\n  font-weight: 300; }\n\n.WelcomePane .PaneTitle {\n  font-weight: 100; }\n  .WelcomePane .PaneTitle b {\n    font-weight: 700; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/RLX/Views/Dashboard/Panes/Welcome/WelcomePane.scss
// module id = 413
// module chunks = 0